import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import type { PickerContainerProps } from '../Picker.types';
import { PickerTrigger } from './PickerTrigger';
import { PickerModalDialogue } from './PickerModalDialogue';

export const PickerContainer = (props: PickerContainerProps) => {
  const {
    label,
    modalTitle,
    submitBtnLabel = 'Submit',
    labelNativeID,
    selectedOptionLabel,
    variation,
    children,
    accessibilityLabel,
    onSubmitBtnPress,
    onDismiss,
  } = props;

  const [isPickerModalShown, setIsPickerModalShown] = useState(false);

  // ─── HELPERS ────────────────────────────────────────────────────────

  const showModal = useCallback(() => {
    setIsPickerModalShown(true);
  }, []);

  const hideModal = useCallback(() => {
    onDismiss();
    setIsPickerModalShown(false);
  }, [onDismiss]);

  const handleOnSubmit = useCallback(() => {
    onSubmitBtnPress();
    setIsPickerModalShown(false);
  }, [onSubmitBtnPress]);

  // ────────────────────────────────────────────────────────────────────

  return (
    <View accessible={true}>
      <PickerTrigger
        label={label}
        accessibilityLabel={accessibilityLabel}
        selectedOption={selectedOptionLabel}
        expanded={isPickerModalShown}
        variation={variation}
        onPress={showModal}
      />

      <PickerModalDialogue
        label={modalTitle ?? label}
        labelNativeID={labelNativeID}
        submitBtnLabel={submitBtnLabel}
        show={isPickerModalShown}
        onSubmit={handleOnSubmit}
        onDismiss={hideModal}
      >
        {children}
      </PickerModalDialogue>
    </View>
  );
};
